@if (isHistorical) {
  <div class="row">
    @if (triage.alertTimeDescription) {
      <div class="tag-recurring-patient">
        <span>Este paciente retornou em menos de
        {{triage.alertTimeDescription}}</span>
      </div>
    }
  </div>
}
<div class="row margin-box-bottom">
  <div class="col-12 col-md-4">
    <div class="status-caller" [ngStyle]="{'background-color': triage.gravityColor}">
      <span class="text-bold">{{ triage.gravityName }}</span>
    </div>
  </div>
</div>
@if (isHistorical) {
  <div class="row">
    <div class="col-6 col-sm-4 col-md-2">
      <h3 class="title-box">Usuário classificador</h3>
      <p class="content-box">{{triage.userClassificationName}}</p>
    </div>
    <div class="col-6 col-sm-4 col-md-2">
      <h3 class="title-box">CRM/COREN</h3>
      <p class="content-box">{{triage.userCouncilNumber}}</p>
    </div>
    <div class="col-6 col-sm-4 col-md-2">
      <h3 class="title-box">Data e hora inicial</h3>
      <p class="content-box">{{triage.startClassification | date:'dd/MM/yy, H:mm' }}</p>
    </div>
    @if (hasEndDateTime) {
      <div class="col-6 col-sm-4 col-md-2">
        <h3 class="title-box">Data e hora final</h3>
        <p class="content-box">{{triage.dateTimeInclusion | date:'dd/MM/yy, H:mm' }}</p>
      </div>
    }
    @if (hasEndDateTime) {
      <div class="col-6 col-sm-4 col-md-2">
        <h3 class="title-box">Tempo de atendimento</h3>
        <p class="content-box">{{triage.serviceTime}}</p>
      </div>
    }
    @if (!isTelephonceClassification) {
      <div class="col-6 col-sm-4 col-md-2">
        <h3 class="title-box">Sala</h3>
        <p class="content-box">{{triage.roomAttendanceName}}</p>
      </div>
    }
  </div>
}
<div class="row margin-box-bottom">
  <div class="col-12 col-sm-12 col-md-12">
    <div class="green-box">
      <h2 class="title-box">Queixa/Motivo</h2>
      <p>{{triage.complaint}}</p>
    </div>
  </div>
</div>
@if (triage.observation) {
  <div class="row margin-box-bottom">
    <div class="col-12 col-sm-12 col-md-12">
      <div class="green-box">
        <h2 class="title-box">Observação</h2>
        <p>{{triage.observation}}</p>
      </div>
    </div>
  </div>
}
<div class="row">
  @if (allergy) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <h3 class="title-box">Alergias</h3>
      <p class="content-box">{{allergy}}</p>
    </div>
  }
  <div class="col-6 col-sm-4 col-md-2 measures-box">
    <h3 class="title-box">Protocolo</h3>
    <p class="content-box">{{protocolName}}</p>
  </div>
  @if (triage.flowchart) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <h3 class="title-box">Fluxograma</h3>
      <p class="content-box">{{triage.flowchart}}</p>
    </div>
  }
  @if (triage.lastFlowchart) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <h3 class="title-box">Fluxograma Anterior</h3>
      <p class="content-box">{{triage.lastFlowchart}}</p>
    </div>
  }
  <div class="col-6 col-sm-4 col-md-2 measures-box">
    <h3 class="title-box">Discriminador</h3>
    <p class="content-box">{{triage.discriminator}}</p>
  </div>
  @if (triage.temperature) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <p class="title-box">Temperatura</p>
      <p class="content-box">{{triage.temperature}}<span class="measures-value-label">°C</span></p>
    </div>
  }
  @if (triage.respiratoryFrequency) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <p class="title-box">Fr. Respiratória</p>
      <p class="content-box">{{triage.respiratoryFrequency}}<span class="measures-value-label">irpm</span></p>
    </div>
  }
  @if (triage.heartRate) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <p class="title-box">Fr. Cardíaca</p>
      <p class="content-box">{{triage.heartRate}}<span class="measures-value-label">bpm</span></p>
      <p class="title-box">
        {{triage.heartRateRegular === true?"Regular": triage.heartRateRegular === false ?"Irregular": ""}}
        {{triage.isHeartRateSleeping === true? ' - Dormindo' : triage.isHeartRateSleeping === false? ' - Acordado' :
        ''}}
      </p>
    </div>
  }
  @if (triage.glucose || triage.glucoseOOR || triage.glucoseComplementaryData || triage.glucoseOorComplementary) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <p class="title-box">Glicemia</p>
      @if (triage.glucose || triage.glucoseComplementaryData) {
        <p class="content-box">{{triage.glucose ?
          triage.glucose : triage.glucoseComplementaryData}}<span class="measures-value-label">mg/dL</span>
        </p>
      }
      @if (triage.glucoseOOR || triage.glucoseOorComplementary) {
        <p class="content-box">{{triage.glucoseOOR ? triage.glucoseOOR : triage.glucoseOorComplementary}}</p>
      }
    </div>
  }
  @if (triage.bloodPressureSystole && triage.bloodPressureDiastole) {
    <div
      class="col-6 col-sm-4 col-md-2 measures-box">
      <p class="title-box">Pressão Arterial</p>
      <p class="content-box">{{triage.bloodPressureSystole && triage.bloodPressureDiastole ?
        triage.bloodPressureSystole + "/" + triage.bloodPressureDiastole : null}}<span
      class="measures-value-label">mmHg</span></p>
    </div>
  }
  @if (triage.saturation) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <p class="title-box">Saturação</p>
      <p class="content-box">{{triage.saturation}}<span class="measures-value-label">%</span></p>
      <p class="title-box">{{triage.atmosphericAir === true?"Ar Atmosférico": triage.atmosphericAir ===
      false ?"Em terapia de O2": ""}}</p>
    </div>
  }
  @if (pain != null) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <p class="title-box">Dor</p>
      <p class="content-box">{{pain}}</p>
      <p class="title-box">{{painType>=min_less_seven && painType <= max_less_seven ?"Menos de 7 dias": painType>=
      min_over_seven && painType <= max_over_seven ?"Mais de 7 dias": "" }}</p>
    </div>
  }
  @if (triage.glasgow) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <p class="title-box">Glasgow </p>
      <p class="content-box">{{triage.glasgow}}</p>
    </div>
  }
  @if (triage.discriminatorSelectionMotive) {
    <div class="col-12 measures-box">
      <p class="title-box">Motivo(Não foi possível aferir os sinais vitais): </p>
      <p class="content-box">{{triage.discriminatorSelectionMotive}}</p>
    </div>
  }

  @if (triage.weight) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <p class="title-box">Peso</p>
      <p class="content-box">{{triage.weight}}<span class="measures-value-label">Kg</span></p>
    </div>
  }
  @if (triage.height) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <p class="title-box">Altura</p>
      <p class="content-box">{{triage.height | number : '1.2'}}<span class="measures-value-label">m</span></p>
    </div>
  }
  @if (triage.fallRisk === true || triage.fallRisk === false) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <p class="title-box">Risco de queda</p>
      <p class="content-box">{{triage.fallRisk === true?"SIM":triage.fallRisk === false? "NÃO": ""}}</p>
    </div>
  }
  @if (triage.suspicionName && !isHistorical) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <p class="title-box">Suspeitas</p>
      <p class="content-box">{{triage.suspicionName}}</p>
    </div>
  }
  @if (triage.diseaseHistory) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <p class="title-box">Comorbidades</p>
      <p class="content-box">{{triage.diseaseHistory}}</p>
    </div>
  }
  @if (!isTelephonceClassification && triage.forwardName) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <h3 class="title-box">Encaminhamento</h3>
      <p class="content-box">{{triage.forwardName}}</p>
    </div>
  }
  @if (isTelephonceClassification && triage.listCounseling) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <h3 class="title-box">Aconselhamentos</h3>
      @for (couseling of triage.listCounseling; track couseling) {
        <p class="content-box">{{couseling.counselingName}}</p>
      }
    </div>
  }
  @if (specialNecessityName) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <h3 class="title-box">Necessidades Especiais</h3>
      <p class="content-box">{{specialNecessityName}}</p>
    </div>
  }
  @if (triage.capillaryFillingTime != null && !triage.capillaryFillingTimeValue) {
    <div
      class="col-6 col-sm-4 col-md-2 measures-box">
      <h3 class="title-box">Perfusão Capilar</h3>
      <p class="content-box">{{triage.capillaryFillingTime === false ?' Menor que 2 segundos (\
        <2s)':(triage.capillaryFillingTime===true ? 'maior que 2 segundos (>2s)' : '' ) }}</p>
      </div>
    }
    @if (triage.capillaryFillingTimeValue) {
      <div class="col-6 col-sm-4 col-md-2 measures-box">
        <h3 class="title-box">Perfusão Capilar</h3>
        <p class="content-box">{{triage.capillaryFillingTimeValue}} Segundos</p>
      </div>
    }
    <!-- <div class="col-12 col-sm-6 col-md-3" *ngIf="isTeletriage">
    <button mat-flat-button type="button" (click)="back()" color="accent" class=" btn-block">
      <mat-icon aria-hidden="false" aria-label="Plus">arrow_back</mat-icon>
      <span *ngIf="!isLoading">Voltar</span>
      <mat-spinner [diameter]="30" class="mat-spinner-btn" *ngIf="isLoading"></mat-spinner>
    </button>
  </div> -->
  @if (triage.healthGuidelineName) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <h3 class="title-box">Protocolo de saúde</h3>
      <p class="content-box">{{triage.healthGuidelineName}}</p>
    </div>
  }
  @if (triage.categorizationName) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <h3 class="title-box">Categorização do protocolo de saúde</h3>
      <p class="content-box">{{triage.categorizationName}}</p>
    </div>
  }
  @if (triage.datetimeStartSymptoms) {
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <h3 class="title-box">Data de início do sintoma</h3>
      <p class="content-box">{{triage.datetimeStartSymptoms | date:'dd/MM/yy, H:mm' }}</p>
    </div>
  }
</div>
@if (isHistorical && triage.scoreTotal) {
  <div class="row">
    <h2>Protocolo NEWS</h2>
    <div class="col-6 col-sm-4 col-md-2 measures-box">
      <h3 class="title-box">SCORE</h3>
      <p class="content-box">{{triage.scoreTotal}}</p>
    </div>
    @if (triage.frequencyName) {
      <div class="col-6 col-sm-4 col-md-2 measures-box">
        <h3 class="title-box">Frequência de monitoramento</h3>
        <p class="content-box">{{triage.frequencyName}}</p>
      </div>
    }
    <div class="col-12 col-md-8">
      <div class="green-box">
        <h2 class="title-box">Resposta clínica</h2>
        <p>{{triage.clinicalResponse}}</p>
      </div>
    </div>
  </div>
}
@if (isHistorical || isAttendPatient) {
  <div class="row">
    <h2>Dados Complementares da Triagem</h2>
    @if (triage.temperatureComplementaryData) {
      <div class="col-6 col-sm-4 col-md-2 measures-box">
        <h3 class="title-box">Temperatura</h3>
        <p class="content-box">{{triage.temperatureComplementaryData}}</p>
      </div>
    }
    @if (isHistorical && triage.bloodPressureDiastoleComplementaryData && triage.bloodPressureSystoleComplementaryData) {
      <div
        class="col-6 col-sm-4 col-md-2 measures-box">
        <h3 class="title-box">Pressão Arterial</h3>
        <p class="content-box">{{triage.bloodPressureSystoleComplementaryData &&
          triage.bloodPressureDiastoleComplementaryData ?
          triage.bloodPressureSystoleComplementaryData + "/" + triage.bloodPressureDiastoleComplementaryData :
          null}}<span class="measures-value-label">mmHg</span></p>
        </div>
      }
      @if (isHistorical && triage.heartRateComplementaryData) {
        <div class="col-6 col-sm-4 col-md-2 measures-box">
          <h3 class="title-box">Fr. Cardíaca</h3>
          <p class="content-box">{{triage.heartRateComplementaryData}}</p>
        </div>
      }
      @if (isHistorical && triage.respiratoryFrequencyComplementaryData) {
        <div
          class="col-6 col-sm-4 col-md-2 measures-box">
          <h3 class="title-box">Fr. Respiratória</h3>
          <p class="content-box">{{triage.respiratoryFrequencyComplementaryData}}</p>
        </div>
      }
      @if (isHistorical && (triage.glucoseComplementaryData || triage.glucoseOorComplementary)) {
        <div class="col-6 col-sm-4 col-md-2 measures-box">
          <h3 class="title-box">Glicemia</h3>
          <p class="content-box">{{triage.glucoseComplementaryData ? triage.glucoseComplementaryData : triage.glucoseOorComplementary}}</p>
        </div>
      }
      @if (isHistorical && triage.saturationComplementaryData) {
        <div class="col-6 col-sm-4 col-md-2 measures-box">
          <h3 class="title-box">Saturação</h3>
          <p class="content-box">{{triage.saturationComplementaryData}}</p>
        </div>
      }
      @if (triage.justification) {
        <div class="col-6 col-sm-4 col-md-2 measures-box">
          <h3 class="title-box">Observação</h3>
          <p class="content-box">{{triage.justification}}</p>
        </div>
      }
    </div>
  }
  @if (isTeletriage && patientForm != null) {
    <div class="row">
      <div class="title-header">
        <div class="row">
          <div class="col-6 col-sm-6 col-md-6">
            <h1>Dados Pessoais</h1>
          </div>
        </div>
      </div>
      <form class="form" [formGroup]="patientForm">
        <div class="row">
          <div class="col-12 col-sm-4 col-md-4">
            <mat-form-field>
              <mat-label>Nome</mat-label>
              <input matInput type="text" readonly formControlName="patientName">
            </mat-form-field>
          </div>
          <div class="col-12 col-sm-4 col-md-4">
            <mat-form-field>
              <mat-label>Data de Nascimento</mat-label>
              <input matInput type="text" readonly [mask]="masks.date" formControlName="birthDate">
            </mat-form-field>
          </div>
          <div class="col-12 col-sm-4 col-md-4">
            <mat-form-field>
              <mat-label>Idade</mat-label>
              <input matInput type="text" readonly formControlName="patientAge">
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
  }
  @if (isTeletriage) {
    <div class="row">
      <div class="offset-6 col-6 offset-md-8 col-md-4">
        <button mat-flat-button (click)="submit()" color="primary" class=" btn-block">
          @if (!isLoading) {
            <span>Salvar</span>
          }
          @if (isLoading) {
            <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          }
        </button>
      </div>
    </div>
  }
  @if (this.triage.triageReportName && isHistorical) {
    <div class="row">
      <div class="col-12 col-sm-6 col-md-2">
        <button mat-flat-button color="primary" class=" btn-block" (click)="downloadTriageReport()">
          @if (!isLoading) {
            <span>Relatório de Classificação</span>
          }
          @if (isLoading) {
            <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          }
        </button>
      </div>
    </div>
  }